import { Dispatch, SetStateAction } from 'react';
import { QueryClient } from 'react-query';
import MlxButton from '../../../../../components/common/MlxButton/MlxButton';
import { OrgPermissionKeys, OrgSubPermissionKeys } from '../../../../../constants/constants';
import { CANCEL, SAVE } from '../../../../../constants/strings';
import { _PermissionGroup, _UserType } from '../../../../../constants/staticTypes';
import { useTranslation } from '../../../../../hooks/useTranslation';
import { checkActionSubPermission } from '../../../../../utils/common';

type _VenuePermissionFooterProps = {
    userType: _UserType | null;
    queryClient: QueryClient;
    venueGroupPermissionList: _PermissionGroup[];
    activeGroupPermission: _PermissionGroup | null;
    setActiveGroupPermission: Dispatch<SetStateAction<_PermissionGroup | null>>;
    setResetKey: Dispatch<SetStateAction<number>>;
    onUpdatePermission: () => void;
    isSaving: boolean;
};

const languageTexts = {
    CANCEL: CANCEL,
    SAVE: SAVE,
};

function VenuePermissionFooter({
    userType,
    queryClient,
    venueGroupPermissionList,
    activeGroupPermission,
    setActiveGroupPermission,
    setResetKey,
    onUpdatePermission,
    isSaving,
}: Readonly<_VenuePermissionFooterProps>) {
    const translatedText = useTranslation(languageTexts, 'pascal');

    return (
        <div className="permission-footer">
            {(userType === 'organizationAdmin' ||
                checkActionSubPermission(
                    queryClient,
                    OrgPermissionKeys.MANAGE_VENUE_PERMISSION,
                    OrgSubPermissionKeys.EDIT_VENUE_PERMISSION
                )) && (
                <>
                    <MlxButton
                        label={translatedText.CANCEL}
                        data-testid="clear-button"
                        icon="ri-close-large-line"
                        iconPos="right"
                        size="small"
                        outlined
                        disabled={isSaving}
                        onClick={(e: React.MouseEvent) => {
                            e.preventDefault();
                            const updatedPermissionGroup = venueGroupPermissionList?.find(
                                (permissionGroup) => permissionGroup.id === activeGroupPermission?.id
                            );
                            if (updatedPermissionGroup) {
                                setActiveGroupPermission(updatedPermissionGroup);
                                setResetKey((prev) => prev + 1);
                            }
                        }}
                    />
                    <MlxButton
                        className="ms-2"
                        label={translatedText.SAVE}
                        data-testid="save-button"
                        icon="ri-check-line"
                        iconPos="right"
                        size="small"
                        loading={isSaving}
                        disabled={isSaving}
                        onClick={(e: React.MouseEvent) => {
                            e.preventDefault();
                            onUpdatePermission();
                        }}
                    />
                </>
            )}
        </div>
    );
}

export default VenuePermissionFooter;
